import React from "react";
import AllRoutes from "./routes/Routes";
import "./assets/scss/Theme.scss";

const App = () => {
  return (
    <>
      <React.Fragment>
        <AllRoutes />
      </React.Fragment>
    </>
  );
};

export default App;
